import { memo } from "react";
import { EuiFlexItem, EuiFlexGroup, EuiTitle } from "@elastic/eui";
import "styles/components/emptyPrompt/fd_empty_prompt.css";

const FDEmptyPrompt = ({
  Body,
  Title,
  TitleSize = "m",
  Size = "l",
  ImageSrc = "/ui/images/logos/logo",
  ImageCls = "prompt-logo ",
  ClassName = "",
  FullWidth = false,
  ShowImage = true,
}) => {
  const imageSrc = `${ImageSrc}-${Size}.svg`;
  return (
    <div>
      <EuiFlexGroup alignItems="center" responsive={false}>
        {!FullWidth && <EuiFlexItem></EuiFlexItem>}
        <EuiFlexItem>
          <EuiFlexGroup
            alignItems="center"
            className={`fd-empty-prompt-wrapper fd-empty-prompt-wrapper--${Size} ${ClassName}`}
            responsive={false}>
            {ShowImage && (
              <EuiFlexItem className="logo-wrapper" grow={false}>
                <img alt="Fortified Data" className={ImageCls} src={imageSrc} />
              </EuiFlexItem>
            )}

            <EuiFlexItem
              className="message-container"
              grow={false}
              style={{ alignContent: "flex-start" }}>
              <>
                {/* @ts-ignore */}
                <EuiTitle size={TitleSize}>
                  <h5 className="txt-color-dark-gray">{Title}</h5>
                </EuiTitle>
                {Body}
              </>
            </EuiFlexItem>
          </EuiFlexGroup>
        </EuiFlexItem>
        {!FullWidth && <EuiFlexItem></EuiFlexItem>}
      </EuiFlexGroup>
    </div>
  );
};

export default memo(FDEmptyPrompt);
